import { useRef } from 'react'
import { useHelper } from '@react-three/drei'
import { DirectionalLightHelper } from 'three'
import { useControls } from 'leva'

export default function Lights()
{
    const directionalLightRef = useRef()
    useHelper(directionalLightRef, DirectionalLightHelper, 1)

    const leva = useControls({intensity:{
        value:0.2,
        min:0,
        max:0.5
    }})

    return <>
        {/* Ambient Light */}
        <ambientLight
            intensity={ leva.intensity }
        />
    </>
}